import { StatusPill } from '../StatusPill';
import type { StatusTone } from '../StatusPill/StatusPill';
import { useT } from '../../i18n';
import type { TranslationKey } from '../../i18n';
import type { Confidence } from '../../types/api';
import styles from './ConfidenceBadge.module.css';

const TONE: Record<Confidence, StatusTone> = {
  K90: 'confidence_k90',
  K50: 'confidence_k50',
  K10: 'confidence_k10',
};

const LABEL_KEY: Record<Confidence, TranslationKey> = {
  K90: 'confidence.k90',
  K50: 'confidence.k50',
  K10: 'confidence.k10',
};

export interface ConfidenceBadgeProps {
  confidence: Confidence | null | undefined;
}

/**
 * K90 / K50 / K10 pill from the Board confidence-basket tokens.
 * Issue #76 — the sign is shown ONLY when the confidence is actually
 * filled: unset renders nothing (no "—" placeholder).
 */
export function ConfidenceBadge({ confidence }: ConfidenceBadgeProps) {
  const { t } = useT();
  if (!confidence) return null;
  return (
    <StatusPill tone={TONE[confidence]} className={styles.badge}>
      {t(LABEL_KEY[confidence])}
    </StatusPill>
  );
}
